export default __webpack_public_path__ + "static/media/announcement_speaker.8d99633d.svg";